<template>
  <footer class="footer px-4">
    <div class="row align-items-center justify-content-lg-between">
      <div class="col-lg-6">
        <div class="copyright text-center text-lg-left text-muted">
          © {{year}} <a href="https://www.iripple.com" class="font-weight-bold ml-1" target="_blank">iRipple, Inc.</a> {{version}}
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { mapState } from 'vuex'
import HTTPRequest from '../controllers/httpRequest.js';

export default {
  data() {
    return {
      year: new Date().getFullYear(),
      version: ''
    };
  },
  mounted: async function() {
    const request = await HTTPRequest.getRequest(`${this.endPoint}settings/latest_web_version`);
    this.version = request.version ? `v${request.version}` : '';
  },
  computed: {
    ...mapState(['endPoint']),
  },
};
</script>
<style></style>
